import React from 'react';
import { FadeUp } from '../motion/FadeUp';
export function Vision() {
  return <section id="vision" className="relative w-full overflow-hidden bg-white px-6 py-32 md:py-44 lg:px-8" data-id="element-171" data-mp="3c2dq7fosd9dc">
      {/* Subtle concentric geometry */}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -z-0 -translate-x-1/2 -translate-y-1/2" data-id="element-172" data-mp="3h3tdzficltzf">
        <svg width="1100" height="1100" viewBox="0 0 1100 1100" fill="none" className="max-w-[150vw] opacity-[0.5]" data-id="element-173" data-mp="3r0potrvpys75">
          {[520, 420, 320, 220, 120].map(r => <circle key={r} cx="550" cy="550" r={r} stroke="#0a0a0a" strokeOpacity="0.05" strokeWidth="1" data-id="element-174" data-mp="3ndlig89tdla" />)}
        </svg>
      </div>

      <div className="relative mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-175" data-mp="ijl4jd7y08yz">
        <FadeUp data-id="element-176" data-mp="3d59nzxwindus">
          <p className="text-xs font-medium uppercase tracking-[0.24em] text-vermillion" data-id="element-177" data-mp="3d5t55cecdy7r">
            Our Vision
          </p>
        </FadeUp>

        <FadeUp delay={0.08} data-id="element-178" data-mp="3855746rp4h41">
          <h2 className="mt-6 text-3xl font-medium leading-snug tracking-tight text-ink/80 md:text-4xl" data-id="element-179" data-mp="3373lpf6ss5pe">
            Our vision is to create a{' '}
            <span className="text-ink" data-id="element-180" data-mp="2z7cniqexynau">Happy, Healthy Humanity.</span>
          </h2>
        </FadeUp>

        <FadeUp delay={0.16} data-id="element-181" data-mp="3vvizjye70hz5">
          <div className="mt-10 select-none text-[26vw] font-bold leading-none tracking-tightest text-ink sm:text-[20vw] md:text-[220px]" aria-label="HHH" data-id="element-182" data-mp="3vxvcfx53g25c">
            HHH
          </div>
        </FadeUp>

        <FadeUp delay={0.24} data-id="element-183" data-mp="3i5fgtheiv6eg">
          <p className="mt-6 text-xl font-medium tracking-wide text-vermillion md:text-2xl" data-id="element-184" data-mp="3i44dfiozo0nv">
            Happy • Healthy • Humanity
          </p>
        </FadeUp>

        <FadeUp delay={0.32} data-id="element-185" data-mp="dq5xu78of0k2">
          <p className="mx-auto mt-10 max-w-2xl text-lg leading-relaxed text-ink/60" data-id="element-186" data-mp="douw0cysk2vl">
            We envision a future where technology doesn&rsquo;t compete for attention
            but contributes to human well-being. Whether through local communities,
            everyday convenience, meaningful relationships, or healthier habits, we
            strive to create products that leave people better than we found them.
          </p>
        </FadeUp>
      </div>
    </section>;
}